import React, { useEffect, useState } from "react";
import { Phone, ChatCircleText } from "@phosphor-icons/react";

// iOS wants "&body=", Android wants "?body=" — "?&body=" satisfies both.
export const smsHref = (body) =>
  `sms:+14108709347${body ? `?&body=${encodeURIComponent(body)}` : ""}`;

// Fixed bottom bar on phones. Hidden while any `watch` selector (hero, the
// form itself) is on screen, so it never covers the thing it points to.
export const MobileActionBar = ({
  primaryLabel,
  primaryHref,
  phoneHref,
  textBody = "Hi HCOB Property Services — ",
  watch = [],
  accent = "#C84B31",
  testid = "mobile-action-bar",
}) => {
  const [show, setShow] = useState(false);
  const watchKey = watch.join("|");

  useEffect(() => {
    const els = watch.map((s) => document.querySelector(s)).filter(Boolean);
    if (!els.length) return undefined;
    const visible = new Map(els.map((el) => [el, true]));
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => visible.set(e.target, e.isIntersecting));
        setShow(![...visible.values()].some(Boolean));
      },
      { threshold: 0.02 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [watchKey]);

  return (
    <>
      <div aria-hidden className="h-[76px] md:hidden" />
      <div
        data-testid={testid}
        data-visible={show ? "true" : "false"}
        aria-hidden={!show}
        className={`fixed inset-x-0 bottom-0 z-40 border-t border-[#1C1A17]/12 bg-[#F5F4F0]/95 backdrop-blur-md transition-transform duration-300 md:hidden ${
          show ? "translate-y-0" : "translate-y-full"
        }`}
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        <div className="flex items-stretch gap-2 px-4 py-2.5">
          <a
            href={primaryHref}
            data-testid={`${testid}-primary`}
            tabIndex={show ? 0 : -1}
            className="flex h-12 flex-1 items-center justify-center rounded-sm text-[14px] font-black text-[#F5F4F0]"
            style={{ backgroundColor: accent }}
          >
            {primaryLabel}
          </a>
          <a
            href={smsHref(textBody)}
            data-testid={`${testid}-text`}
            aria-label="Text us at (410) 870-9347"
            tabIndex={show ? 0 : -1}
            className="flex h-12 shrink-0 flex-col items-center justify-center rounded-sm border border-[#1C1A17] px-3 text-[#1C1A17]"
          >
            <ChatCircleText size={18} weight="fill" />
            <span className="mt-0.5 text-[10px] font-bold uppercase leading-none tracking-wider">Text</span>
          </a>
          <a
            href={phoneHref}
            data-testid={`${testid}-call`}
            aria-label="Call (410) 870-9347"
            tabIndex={show ? 0 : -1}
            className="grid h-12 w-12 shrink-0 place-items-center rounded-sm border border-[#1C1A17] text-[#1C1A17]"
          >
            <Phone size={18} weight="fill" />
          </a>
        </div>
      </div>
    </>
  );
};
